import type { MenuCategory } from "../types/menu";

// Desayunos
import calentadito from "@/assets/menu/DESAYUNOS/CALENTADITO.webp";
import manaba from "@/assets/menu/DESAYUNOS/MANABA.webp";
import guayaco from "@/assets/menu/DESAYUNOS/GUAYACO.webp";
import zarumeño from "@/assets/menu/DESAYUNOS/ZARUMEÑO.webp";
import machaleño from "@/assets/menu/DESAYUNOS/MACHALEÑO.webp";

import americano_wafle from "@/assets/menu/DESAYUNOS/AMERICANO WAFLE.webp";
import esmeraldeño from "@/assets/menu/DESAYUNOS/AMERICANO WAFLE.webp";


// Bolones
import bolonesEspecial from "@/assets/menu/BOLONES/BOLÓN ESPECIAL.webp";

// Tigrillos
import tigrilloMixto from "@/assets/menu/Tigrillo/TIGRILLO MIXTO.webp";
import tigrilloTriple from "@/assets/menu/Tigrillo/TIGRILLO TRIPLE.webp";
import tigrilloSencillo from "@/assets/menu/Tigrillo/SENCILLO.webp";


// Patacones
import pataconespecial from "@/assets/menu/PATACONES/ESPECIAL.webp";

// Encebollados
import encebollado from "@/assets/menu/ENCEBOLLADOS/ENCEBOLLADO.webp";
import encebollado_marinero from "@/assets/menu/ENCEBOLLADOS/MARINERO.webp";

// Sopas
import caldoBolas from "@/assets/menu/SOPAS/El Verde 2.webp";

// Cazuelas
import cazuelaCamaron from "@/assets/menu/CAZUELA/CAZUELA  DE CAMARÓN.webp";
import cazuelaMixta from "@/assets/menu/CAZUELA/CAZUELA MIXTA.webp";

// Ceviches
import cevicheCamaron from "@/assets/menu/CEVICHES/CEVICHE CAMARÓN.webp";
import arrozMarinero from "@/assets/menu/CEVICHES/ARROZ MARINERO.webp";

// Apanados
import camaronesApanados from "@/assets/menu/APANADOS/CAMARONES.webp";
import corvinaApanada from "@/assets/menu/APANADOS/CORVINA.webp";

// Banderas
import banderaTriple from "@/assets/menu/BANDERAS/BANDERA TRIPLE.webp";

// Especialidades
import majarisco from "@/assets/menu/especialidades/MAJARISCO.webp";
import colonche from "@/assets/menu/especialidades/COLONCHE.webp";
import pescadoFrito from "@/assets/menu/especialidades/PESCADO FRITO.webp";
import corvinaLoMacho from "@/assets/menu/especialidades/CORVINA A LO MACHO.webp";
import corvinaAlVapor from "@/assets/menu/especialidades/CORVINA AL VAPOR.webp";
import rondaMarinera from "@/assets/menu/especialidades/RONDA MARINERA.webp";
import conchasAsadas from "@/assets/menu/especialidades/CONCHAS ASADAS.webp";

// Mollocos
import molloc_especial from "@/assets/menu/Mollocos/molloco_especial.webp";

// Majados
import majados from "@/assets/menu/Majados/majado_montubio.webp";

// Encocados
import encocado_mixto from "@/assets/menu/encocados/MIXTO.webp";
import encocado_marinero from "@/assets/menu/encocados/MARINERO.webp";


// Bebidas Frias
import limonada from "@/assets/menu/bebidas_frias/LIMONADA.webp"
import limonada_coco from "@/assets/menu/bebidas_frias/LIMONADA DE COCO.webp"
import jugo_natural from "@/assets/menu/bebidas_frias/JUGO NATURAL .webp"

// Postres
import cheescake from "@/assets/menu/postres/CHEESECAKE.webp"



export const menuData: MenuCategory[] = [
  // ── DESAYUNOS ─────────────────────────────────────────────────────────────
  {
    id: "desayunos",
    name: "Desayunos",
    description: "",
    items: [
      {
        id: "des1",
        name: "Americano Waffle",
        description:
          "Comienza tu mañana con 2 rebanadas de pan tostado crujiente, 2 huevos revueltos jugosos, tocino dorado, mermelada y mantequilla. ¡Energía para todo el día!",
        price: 6.0,
        image: americano_wafle
      },
      {
        id: "des2",
        name: "Calentadito",
        description: "Disfruta de un reconfortante revuelto de huevo con arroz calentito, tocino crujiente y queso derretido.",
        price: 5.0,
        image: calentadito,
      },
      {
        id: "des3",
        name: "Manaba",
        description:
          "Saborea la tradición con esta tortilla de verde con queso fundido, acompañada de 2 huevos fritos y el toque único de la sal prieta.",
        price: 5.75,
        image: manaba,
      },
      {
        id: "des4",
        name: "Esmeraldeño",
        description: "Prueba nuestros 6 patacones crujientes acompañados de 2 huevos al gusto y queso amasado fresco.",
        price: 6.5,
        image: esmeraldeño
      },
      {
        id: "des8",
        name: "Piñasiense",
        description:
          "Experimenta la mezcla perfecta de majado de plátano maduro con queso y maní, coronado con 1 huevo frito.",
        price: 8.75,
      },
      {
        id: "des5",
        name: "Guayaco",
        description:
          "Déjate tentar por este bolón de verde con chicharrón y queso, bañado en cremosa salsa de queso, sal prieta y tocino crujiente.",
        price: 7.0,
        image: guayaco,
      },

      {
        id: "des6",
        name: "Zarumeño",
        image: zarumeño,
        description: "Deléitate con un tigrillo sencillo acompañado de un huevo frito perfecto y jugoso bistec de carne.",
        price: 8.75,
      },
      {
        id: "des7",
        name: "Machaleño",
        featured: true,
        description:
          "Pide el favorito de la casa: majado de plátano verde con queso, 1 huevo frito y tierno bistec de carne.",
        price: 7.75,
        image: machaleño,
      },
      {
        id: "des9",
        name: "Montubio",
        description: "Descubre el sabor auténtico del majado de verde o maduro con camarones salteados en una irresistible salsa de maní.",
        price: 8.0,
      },
    ],
  },

  // ── BOLONES DE VERDE ──────────────────────────────────────────────────────
  {
    id: "bolones",
    name: "Bolones de Verde",
    description: "",
    items: [
      {
        id: "bol1",
        name: "Bolón de Queso",
        description: "Prueba nuestro crujiente bolón de verde relleno de queso derretido, tostado a la plancha hasta quedar dorado.",
        price: 3.25,
      },
      {
        id: "bol2",
        name: "Bolón de Chicharrón",
        description: "Siente el sabor crujiente de este bolón de verde con chicharrón de cerdo premium, tostado a la plancha.",
        price: 4.0,
      },
      {
        id: "bol3",
        name: "Bolón de Tocino",
        description: "Prueba la perfecta combinación de verde tostado a la plancha con trozos de tocino ahumado y crujiente.",
        price: 4.0,
      },
      {
        id: "bol4",
        name: "Bolón Mixto",
        description:
          "Elige tu combinación favorita: bolón de verde relleno de chicharrón y queso, o queso y tocino, dorado a la plancha.",
        price: 4.0,
      },
      {
        id: "bol5",
        name: "Bolón Mixto Plus",
        description: "Disfruta del doble sabor con este bolón de verde relleno de chicharrón crujiente y tocino ahumado.",
        price: 4.0,
      },
      {
        id: "bol6",
        name: "Bolón Triple",
        description:
          "Atrévete con el definitivo: bolón de verde relleno de chicharrón, queso y tocino, tostado a la plancha.",
        price: 4.3,
      },
      {
        id: "bol7",
        name: "Bolón Especial",
        featured: true,
        description:
          "Déjate sorprender por nuestra especialidad: bolón de verde con chicharrón y queso, bañado en salsa de queso, sal prieta y tocino crujiente.",
        price: 6.5,
        image: bolonesEspecial,
      },
    ],
  },

  // ── MOLLOCOS (BOLONES DE MADURO) ──────────────────────────────────────────
  {
    id: "mollocos",
    name: "Mollocos",
    description: "Bolones de plátano maduro",
    items: [
      {
        id: "mol1",
        name: "Molloco Especial",
        description:
          "Vive una experiencia única con este majado de plátano maduro con maní y chicharrón, envuelto en hoja de plátano y bañado con queso fundido, salsa de queso, sal prieta y tocino.",
        price: 7.0,
        image: molloc_especial,
        featured: true,
      },
      {
        id: "mol2",
        name: "Molloco de Queso",
        description:
          "Disfruta el contraste de este bolón de plátano maduro con maní y queso fundido, tostado a la plancha.",
        price: 3.25,
      },
      {
        id: "mol3",
        name: "Molloco de Chicharrón",
        description:
          "Prueba el increíble balance del plátano maduro con maní y crujiente chicharrón, tostado a la plancha.",
        price: 4.0,
      },
      {
        id: "mol4",
        name: "Molloco de Tocino",
        description:
          "Combina el dulce del maduro y maní con el salado del tocino ahumado, tostado a la plancha.",
        price: 4.0,
      },
      {
        id: "mol5",
        name: "Molloco Mixto",
        description:
          "Saborea la mezcla perfecta de maduro con maní, chicharrón y queso fundido a la plancha.",
        price: 4.0,
      },
    ],
  },

  // ── TIGRILLOS ─────────────────────────────────────────────────────────────
  {
    id: "tigrillos",
    name: "Tigrillos",
    description: "",
    items: [
      {
        id: "tig2",
        name: "Tigrillo Mixto",
        description:
          "Saborea nuestro cremoso majado de verde revuelto con cebolla, huevo, queso tierno y trozos crujientes de chicharrón. ¡Un estallido de sabor!",
        price: 5.5,
        image: tigrilloMixto,
        featured: true,
      },
      {
        id: "tig3",
        name: "Tigrillo Triple",
        description:
          "Pide el definitivo: majado de verde revuelto con cebolla, queso derretido, chicharrón crujiente y tocino ahumado. ¡Máxima delicia!",
        price: 6.5,
        image: tigrilloTriple,
      },
      {
        id: "tig1",
        name: "Tigrillo Sencillo",
        description: "Disfruta de la receta clásica y reconfortante: majado de verde revuelto con cebolla salteada, huevo y queso derretido.",
        price: 4.3,
        image: tigrilloSencillo
      },
    ],
    addonsLabel: "Porciones adicionales",
    addons: [
      { name: "1 Huevo Frito", price: 0.75 },
      { name: "2 Huevos Revueltos", price: 1.5 },
      { name: "3 onz de Sal Prieta", price: 1.25 },
      { name: "3 onz de Queso", price: 1.25 },
      { name: "3 onz de Chicharrón", price: 3.75 },
      { name: "2 onz de Tocino", price: 3.25 },
      { name: "Salsa de Queso Blanco", price: 2.0 },
      { name: "Jugo de Bistec", price: 1.0 },
      { name: "Bistec de Carne", price: 3.5 },
      { name: "Alfajores Doña Clemen", price: 2.25 },
    ],
  },

  // ── TORTILLAS ─────────────────────────────────────────────────────────────
  {
    id: "tortillas",
    name: "Tortillas",
    description: "",
    items: [
      {
        id: "tor1",
        name: "Tortilla de Verde",
        description: "Prueba esta crujiente tortilla de majado de plátano verde rellena de queso, dorada a la plancha.",
        price: 3.25,
      },
      {
        id: "tor2",
        name: "Tortilla de Maduro",
        description: "Deléitate con el dulce sabor de nuestra tortilla de plátano maduro con queso fundido a la plancha.",
        price: 3.25,
      },
    ],
  },

  // ── MAJADOS ───────────────────────────────────────────────────────────────
  {
    id: "majados",
    name: "Majados",
    description: "De plátano verde o maduro",
    items: [
      {
        id: "maj1",
        name: "Majado",
        description: "Elige tu base favorita y disfruta de este tradicional majado de plátano verde o maduro hecho al instante.",
        price: 2.3,
      },
      {
        id: "maj2",
        name: "Majado Montubio",
        featured: true,
        description:
          "Sorpréndete con un imponente majado de verde o maduro con queso amasado, salsa de queso, chicharrones y bañado en salsa de maní con camarones y tocino.",
        price: 8.0,
        image: majados
      },
    ],
    addonsLabel: "Agrégale el aderezo preferido a tu majado",
    addons: [
      { name: "Queso Amasado", price: 1.0 },
      { name: "Salsa de Queso", price: 1.5 },
      { name: "Chicharrón", price: 3.5 },
      { name: "Tocino", price: 3.0 },
      { name: "Camarones en Salsa de Maní", price: 4.6 },
    ],
  },

  // ── PATACONES ─────────────────────────────────────────────────────────────
  {
    id: "patacones",
    name: "Patacones",
    description: "",
    items: [
      {
        id: "pat1",
        name: "Patacones (15 unidades)",
        description: "Comparte (o quédatelos todos) 15 espectaculares patacones dorados, súper crocantes por fuera y suaves por dentro.",
        price: 6.5,
      },
      {
        id: "pat2",
        name: "Patacones (8 unidades)",
        description: "Acompaña tus platos con 8 patacones perfectamente dorados, crujientes y suaves.",
        price: 4.25,
      },
      {
        id: "pat3",
        name: "Patacón Especial",
        description:
          "Atrévete a probar estos 15 patacones crujientes bañados en cremosa salsa de queso, queso amasado fundido y trocitos de tocino.",
        price: 8.5,
        featured: true,
        image: pataconespecial,
      },
    ],
  },

  // ── ENCEBOLLADOS ──────────────────────────────────────────────────────────
  {
    id: "encebollados",
    name: "Encebollados",
    description: "Incluye chifles y tostado",
    items: [
      {
        id: "enc1",
        name: "Encebollado de Pescado",
        description: "Revive con el clásico ecuatoriano: albacora fresca cocida en un caldo concentrado de yuca, cilantro y cebolla colorada.",
        image: encebollado,
        featured: true,
        sizes: [
          { label: "Junior", price: 3.6 },
          { label: "Normal", price: 4.75 },
          { label: "Jumbo", price: 7.15 },
        ],
      },
      {
        id: "enc3",
        name: "Encebollado Marinero",
        image: encebollado_marinero,
        description: "Disfruta de nuestra versión más completa, cargada de pescado fresco, camarones y exquisitos mariscos seleccionados.",
        sizes: [
          { label: "Normal", price: 7.5 },
          { label: "Jumbo", price: 9.75 },
        ],
      },
      {
        id: "enc2",
        name: "Encebollado + Camarón",
        description: "Prueba el delicioso poder del mar con este encebollado de pescado coronado con jugosos camarones salteados.",
        sizes: [
          { label: "Junior", price: 5.5 },
          { label: "Normal", price: 7.75 },
          { label: "Jumbo", price: 10.0 },
        ],
      },
    ],
  },

  // ── SOPAS ─────────────────────────────────────────────────────────────────
  {
    id: "sopas",
    name: "Sopas",
    description: "Disponible viernes, sábado y domingo",
    items: [
      {
        id: "sop1",
        name: "Caldo de Bolas",
        description: "Saborea un reconfortante caldo de res con vegetales y una gran bola de verde rellena de carne sazonada, huevo y pasas.",
        image: caldoBolas,
        featured: true,
        sizes: [
          { label: "Normal (10 oz de carne)", price: 7.5 },
          { label: "Jumbo (1 lb de carne)", price: 9.0 },
        ],
      },
    ],
  },

  // ── CAZUELAS ──────────────────────────────────────────────────────────────
  {
    id: "cazuelas",
    name: "Cazuelas",
    description: "Incluye arroz",
    items: [
      {
        id: "caz2",
        name: "Cazuela de Camarón",
        description:
          "Deléitate con esta sustanciosa y espesa sopa de verde horneada en vasija de barro, cocinada en un concentrado consomé de camarón fresco.",
        image: cazuelaCamaron,
        sizes: [
          { label: "Junior", price: 8.5 },
          { label: "Normal", price: 11.75 },
        ],
      },
      {
        id: "caz3",
        name: "Cazuela Mixta",
        description:
          "Descubre nuestra exquisita cazuela de verde horneada con una deliciosa combinación de albacora y camarones jugosos.",
        image: cazuelaMixta,
        featured: true,
        sizes: [
          { label: "Junior", price: 8.0 },
          { label: "Normal", price: 11.5 },
        ],
      },
      {
        id: "caz1",
        name: "Cazuela de Pescado",
        description:
          "Prueba la tradicional cazuela de verde horneada a fuego lento con albacora fresca en un consomé lleno de tradición.",
        sizes: [
          { label: "Junior", price: 7.75 },
          { label: "Normal", price: 11.0 },
        ],
      },
      {
        id: "caz4",
        name: "Cazuela de Mariscos",
        description:
          "Déjate conquistar por un festín de mariscos horneados en nuestra tradicional masa de verde y consomé marino.",
        sizes: [
          { label: "Junior", price: 8.0 },
          { label: "Normal", price: 11.5 },
        ],
      },
    ],
  },

  // ── CEVICHES ──────────────────────────────────────────────────────────────
  {
    id: "ceviches",
    name: "Ceviches",
    description: "Incluye patacones",
    items: [
      {
        id: "ce1",
        name: "Ceviche de Camarón",
        description: "Refréscate con camarones seleccionados, curtidos al instante en jugo de limón y naranja con cebolla morada y cilantro.",
        price: 11.0,
        featured: true,
        image: cevicheCamaron,
      },
      {
        id: "ce8",
        name: "Arroz Marinero",
        description: "Disfruta de una generosa mixtura de mariscos frescos salteados con cebolla, pimiento y zanahoria sobre arroz aromatizado.",
        price: 14.75,
        image: arrozMarinero,
      },
      {
        id: "ce2",
        name: "Ceviche de Corvina",
        description: "Saborea cubos de corvina fresca marinados en cítricos frescos, cebolla colorada y un toque de cilantro.",
        price: 11.25,
      },
      {
        id: "ce3",
        name: "Ceviche Mixto",
        description: "Disfruta de la combinación perfecta de corvina fresca y camarones tiernos curtidos en limón y naranja.",
        price: 11.0,
      },
      {
        id: "ce4",
        name: "Ceviche Marinero",
        description: "Prueba nuestra selección de mariscos frescos curtidos en cítricos con cebolla morada, tomate y cilantro.",
        price: 11.0,
      },
      {
        id: "ce5",
        name: "Ceviche de Concha",
        description: "Experimenta la intensidad de las conchas negras frescas, abiertas al instante y marinadas en limón y cebolla colorada.",
        price: 15.0,
      },
      {
        id: "ce6",
        name: "Ceviche con Concha",
        description: "Exquisita combinación de conchas y camarones frescos marinado en cítricos al estilo tradicional.",
        price: 15.0,
      },
      {
        id: "ce7",
        name: "Arroz con Camarón",
        description: "Pide este clásico con 15 generosos camarones salteados con cebolla, pimiento, zanahoria y arroz de la casa.",
        price: 14.75,
      },

      {
        id: "ce9",
        name: "Arroz Con Concha",
        description: "Saborea nuestro arroz meloso salteado con jugosas conchas negras abiertas en su propio jugo aromático.",
        price: 15.0,
      },
    ],
  },

  // ── APANADOS ──────────────────────────────────────────────────────────────
  {
    id: "apanados",
    name: "Apanados",
    description: "",
    items: [
      {
        id: "ap1",
        name: "Camarones Apanados",
        description:
          "Prueba nuestros camarones apanados súper crujientes, acompañados de arroz blanco, patacones dorados y ensalada fresca.",
        image: camaronesApanados,
        featured: true,
        sizes: [
          { label: "Junior", price: 8.5 },
          { label: "Normal", price: 11.5 },
        ],
      },
      {
        id: "ap2",
        name: "Filete de Corvina Apanado",
        description:
          "Disfruta de un filete de corvina apanado a la perfección, tierno por dentro y crujiente por fuera, con arroz, patacones y ensalada.",
        image: corvinaApanada,
        sizes: [
          { label: "Junior", price: 8.5 },
          { label: "Normal", price: 11.5 },
        ],
      },
      {
        id: "ap3",
        name: "Chicharrón de Corvina",
        description:
          "Saborea deliciosos bocados de corvina apanada fritos al instante, servidos con arroz, patacones y ensalada de la casa.",
        price: 13.5,
      },
      {
        id: "ap4",
        name: "Chicharrón Mixto",
        description:
          "Pide el doble placer: cubos de corvina y camarones apanados súper crujientes con arroz, patacones y ensalada.",
        price: 13.5,
      },
      {
        id: "ap5",
        name: "Picadita Marinera",
        description:
          "Comparte momentos especiales con esta picadita de corvina y camarones apanados, acompañados de crocantes patacones.",
        price: 13.5,
      },
    ],
  },

  // ── ENCOCADOS ─────────────────────────────────────────────────────────────
  {
    id: "encocados",
    name: "Encocados",
    description: "",
    items: [
      {
        id: "eco1",
        name: "Encocado Marinero",
        image: encocado_marinero,
        featured: true,
        description:
          "Disfruta de un festín tropical con esta mixtura de mariscos seleccionados en salsa de coco natural, acompañada de arroz y patacones.",
        price: 12.75,
      },
      {
        id: "eco2",
        name: "Encocado Mixto",
        image: encocado_mixto,
        description:

          "Prueba la perfecta armonía de filete de corvina y camarones cocinados en nuestra deliciosa salsa de coco artesanal, con arroz y patacones.",
        price: 16.25,
      },
      {
        id: "eco3",
        name: "Encocado de Camarón",
        description:
          "Déjate seducir por 12 jugosos camarones cocinados a fuego lento en una aromática salsa de coco fresco, con arroz y patacones.",
        price: 12.75,
      },
      {
        id: "eco4",
        name: "Encocado de Corvina",
        description:
          "Siente el verdadero sabor de Esmeraldas con este filete de corvina bañado en cremosa salsa de coco, con arroz y patacones.",
        price: 12.75,
      },


    ],
  },

  // ── ESPECIALIDADES ────────────────────────────────────────────────────────
  {
    id: "especialidades",
    name: "Especialidades",
    description: "",
    items: [
      {
        id: "esp1",
        name: "Majarisco",
        description:
          "Experimenta la gloria culinaria con esta imponente torre de majado de verde bañada en salsa cremosa gourmet rebosante de mariscos frescos.",
        price: 14.5,
        featured: true,
        image: majarisco,
      },
      {
        id: "esp5",
        name: "Corvina al Vapor",
        description:
          "Cuida tu salud sin perder el sabor: filete de corvina cocinado al vapor con una fresca selección de cebolla, tomate y pimientos.",
        price: 13.0,
        image: corvinaAlVapor,
      },
      {
        id: "esp7",
        name: "Ronda Marinera",
        description:
          "Reúne a tu mesa y deléitense con arroz marinero, ceviche a elección, chicharrón mixto, majarisco y encocado de camarón. ¡Perfecta para compartir!",
        price: 25.0,
        image: rondaMarinera,
      },
      {
        id: "esp2",
        image: colonche,
        name: "Colonche",
        description:
          "Descubre esta joya montubia: base de patacones troceados y rebozados en una espectacular salsa de maní con camarones tiernos.",
        price: 14.0,
      },
      {
        id: "esp3",
        image: pescadoFrito,
        name: "Pescado Frito",
        description:
          "Disfruta de una impresionante corvina entera frita de 1 1/2 lbs, dorada al punto perfecto, con arroz, patacones y ensalada fresca.",
        price: 15.5,
      },
      {
        id: "esp4",
        name: "Corvina a lo Macho",
        image: corvinaLoMacho,
        description:
          "Atrévete con esta corvina apanada frita y generosamente bañada en salsa cremosa con mariscos, servida con arroz y patacones.",
        price: 15.0,
      },

      {
        id: "esp6",
        name: "Trío Marinero",
        description:
          "Saborea la trilogía perfecta de la casa: arroz marinero, ceviche a elección y chicharrón de mariscos súper crujiente.",
        price: 19.0,
      },


      {
        id: "esp9",
        name: "Trío de Conchas",
        description: "Prueba la máxima expresión de la concha: ceviche de conchas negras, arroz con conchas y conchas asadas calientitas.",
        price: 0,
      },
      {
        id: "esp10",
        name: "Trío de Ceviches",
        description:
          "Sorprende a tu paladar con este trío de ceviche de conchas, ceviche de camarón y ceviche de pescado, coronado con 4 camarones.",
        price: 0,
      },
      {
        id: "esp8",
        name: "Conchas Asadas",
        image: conchasAsadas,
        description: "Deléitate con 12 conchas asadas a la brasa en su propio jugo con el toque de la casa, acompañadas de patacones crocantes.",
        price: 15.0,
      },
    ],
  },

  // ── SECOS ─────────────────────────────────────────────────────────────────
  {
    id: "secos",
    name: "Secos",
    description: "",
    items: [
      {
        id: "sec1",
        name: "Guatita",
        description: "Saborea la clásica guatita tierna en salsa cremosa de maní, servida con arroz calientito y maduros fritos.",
        price: 5.5,
      },
      {
        id: "sec2",
        name: "Bistec de Carne",
        description: "Prueba nuestro tierno y jugoso bistec de carne salteado con cebolla y tomate, acompañado de arroz y maduritos.",
        price: 5.5,
      },
    ],
  },

  // ── BANDERAS ──────────────────────────────────────────────────────────────
  {
    id: "banderas",
    name: "Banderas",
    description: "",
    items: [
      {
        id: "ban1",
        name: "Bandera Doble",
        description: "Combina dos sabores espectaculares: guatita + cazuela o guatita + bistec. ¡Ideal para los indecisos!",
        price: 8.5,
      },
      {
        id: "ban2",
        name: "Bandera Triple",
        description:
          "Disfruta de la trilogía perfecta: guatita + cazuela + encebollado o guatita + bistec + encebollado.",
        price: 10.25,
        featured: true,
        image: banderaTriple,
      },
      {
        id: "ban3",
        name: "Bandera Cuádruple",
        description: "Atrévete con el festín completo de guatita, cazuela, encebollado y ceviche de camarón en un solo plato.",
        price: 11.5,
      },
    ],
  },

  // ── BEBIDAS FRÍAS ─────────────────────────────────────────────────────────
  {
    id: "bebidas_frias",
    name: "Bebidas Frías",
    description: "",
    items: [
      {
        id: "bf5",
        name: "Limonada Especial",
        featured: true,
        description: "Calma tu sed con nuestra deliciosa y refrescante limonada especial con el toque de la casa.",
        price: 3.0,
        image: limonada
      },
      {
        id: "bf6",
        name: "Limonada de Coco",
        description: "Prueba la perfecta combinación tropical de jugo de limón y crema de coco bien fría.",
        price: 3.5,
        image: limonada_coco
      },

      {
        id: "bf2",
        name: "Jugo de Naranja",
        description: "Disfruta de un vaso de jugo de naranja 100% natural y recién exprimido.",
        price: 3.9,
      },
      {
        id: "bf3",
        name: "Jarra de Jugo Natural",
        description: "Pide una jarra bien fría de jugo natural de mora, naranjilla, tomate de árbol o maracuyá para compartir.",
        price: 6.25,
      },
      {
        id: "bf1",
        name: "Jugo Natural",
        description:
          "Refréscate con jugo natural de mora, naranjilla, tomate de árbol o maracuyá en un generoso vaso de 500ml.",
        price: 2.9,
        image: jugo_natural
      },
      {
        id: "bf4",
        name: "Jarra de Jugo de Naranja",
        description: "Comparte frescura con nuestra jarra de jugo de naranja 100% natural, recién preparado.",
        price: 8.0,
      },


      {
        id: "bf7",
        name: "Coco Maracuyá",
        description: "Experimenta una explosión tropical única mezclando coco y maracuyá en una bebida refrescante.",
        price: 3.5,
      },
      {
        id: "bf8",
        name: "Maracumango",
        description: "Saborea la irresistible fusión helada de maracuyá y mango maduro.",
        price: 3.5,
      },
      {
        id: "bf9",
        name: "Milkshake",
        description:
          "Deléitate con un milkshake cremoso de mora, naranjilla, tomate de árbol o maracuyá en vaso de 500ml.",
        price: 3.75,
      },
      {
        id: "bf10",
        name: "Gaseosa Personal",
        description: "Acompaña tu comida con una gaseosa personal helada a tu elección.",
        price: 1.5,
      },
      {
        id: "bf11",
        name: "Gaseosa 500ml",
        description: "Refresca tu paladar con una gaseosa fría de 500ml.",
        price: 2.5,
      },
      {
        id: "bf12",
        name: "Agua con Gas",
        description: "Hidrátate con una botella de agua mineral con gas bien helada.",
        price: 1.25,
      },
      {
        id: "bf13",
        name: "Agua sin Gas",
        description: "Refréscate de forma natural con una botella de agua pura sin gas.",
        price: 1.0,
      },
    ],
  },

  // ── CERVEZAS ──────────────────────────────────────────────────────────────
  {
    id: "cervezas",
    name: "Cervezas",
    description: "",
    items: [
      {
        id: "cer1",
        name: "Club 330cc",
        description: "Refréscate con una Club de 330cc helada, ideal para acompañar tus platos marinos.",
        price: 3.5,
      },
      {
        id: "cer2",
        name: "Corona 355cc",
        description: "Disfruta de una Corona de 355cc con una rodaja de limón. ¡Frescura garantizada!",
        price: 3.75,
      },
      {
        id: "cer3",
        name: "Stella Artois 330cc",
        description: "Prueba el sabor premium de una Stella Artois de 330cc bien helada.",
        price: 3.75,
      },
      {
        id: "cer4",
        name: "Cerveza Paulaner",
        description: "Saborea la tradición alemana con una exquisita cerveza de trigo Paulaner.",
        price: 5.5,
      },
    ],
  },

  // ── CAFÉ & BEBIDAS CALIENTES ──────────────────────────────────────────────
  {
    id: "cafe",
    name: "Café & Bebidas Calientes",
    description: "",
    items: [
      {
        id: "caf1",
        name: "Americano",
        description: "Despierta tus sentidos con nuestro café americano aromático y equilibrado de 9 onz.",
        price: 2.25,
      },
      {
        id: "caf2",
        name: "Espresso",
        description: "Pide un espresso de 2 onz cargado de energía y un aroma inigualable.",
        price: 2.0,
      },
      {
        id: "caf3",
        name: "Doble Espresso",
        description: "Duplica la energía con este espresso doble de 4 onz para los amantes del buen café.",
        price: 2.5,
      },
      {
        id: "caf4",
        name: "Cortadito",
        description: "Prueba nuestro delicioso cortadito de 4 onz, la mezcla perfecta de espresso y un toque de leche cremosa.",
        price: 2.5,
      },
      {
        id: "caf5",
        name: "Latte",
        description: "Disfruta de un suave latte de 9 onz preparado con leche vaporizada a la perfección.",
        price: 2.6,
      },
      {
        id: "caf6",
        name: "Leche Manchada",
        description: "Prueba la reconfortante leche manchada de 9 onz, ideal para cualquier momento del día.",
        price: 2.6,
      },
      {
        id: "caf7",
        name: "Capuchino",
        description: "Deléitate con este capuchino de 9 onz coronado con una cremosa y densa espuma de leche.",
        price: 3.0,
      },
      {
        id: "caf8",
        name: "Mocachino",
        description: "Combina lo mejor de dos mundos con este dulce mocachino de 9 onz con cacao premium y café.",
        price: 3.0,
      },
      {
        id: "caf9",
        name: "Capuchino Vainilla",
        description: "Saborea el sutil aroma a vainilla en nuestro cremoso capuchino de 9 onz.",
        price: 3.0,
      },
      {
        id: "caf10",
        name: "Mocachino Vainilla",
        description: "Regálate un capricho con este mocachino con un delicado toque de vainilla dulce de 9 onz.",
        price: 3.0,
      },
      {
        id: "caf11",
        name: "Chocolate en Agua",
        description: "Caliéntate con un tradicional chocolate en agua de 9 onz, lleno de sabor artesanal.",
        price: 1.75,
      },
      {
        id: "caf12",
        name: "Chocolate en Leche",
        description: "Disfruta del clásico chocolate caliente preparado con leche cremosa de 9 onz.",
        price: 2.25,
      },
      {
        id: "caf13",
        name: "Café Bombón",
        description: "Prueba esta dulce tentación: espresso concentrado servido sobre una suave capa de leche condensada de 5 onz.",
        price: 4.0,
      },
      {
        id: "caf14",
        name: "Infusión",
        description: "Relájate con una infusión herbal caliente de 9 onz, perfecta para cerrar tu velada.",
        price: 1.75,
      },
    ],
  },

  // ── POSTRES ───────────────────────────────────────────────────────────────
  {
    id: "postres",
    name: "Postres",
    description: "",
    items: [
      {
        id: "pos1",
        name: "Alfajor Doña Cleme",
        description:
          "Déjate tentar por dos deliciosas galletas grandes rellenas con abundante manjar de leche y bañadas en chocolate fino.",
        price: 2.25,
      },
      {
        id: "pos2",
        name: "Afogato",
        description: "Experimenta la gloria del afogato: una bola de helado de vainilla cremosa derretida en un espresso caliente.",
        price: 2.6,
      },
      {
        id: "pos3",
        name: "Frozen Capuchino",
        description: "Refréscate con esta versión frapeada de capuchino bien helada y cremosa.",
        price: 3.25,
      },
      {
        id: "pos4",
        name: "Frozen mocachino.",
        description: "Prueba el lado más fresco del chocolate y café con este frozen mocachino irresistible.",
        price: 3.25,
      },
      {
        id: "pos5",
        name: "Alfajor con Helado y Crema",
        description: "Consiéntete con un alfajor artesanal servido con una bola de helado de vainilla y crema batida.",
        price: 3.25,
      },
      {
        id: "pos6",
        name: "Bocadillos Doña Cleme",
        description: "Lleva a casa esta deliciosa funda de 24 bocadillos tradicionales para endulzar el día de todos.",
        price: 2.0,
      },
      {
        id: "pos7",
        name: "Waffle",
        description: "Pide este espectacular waffle crujiente servido con helado cremoso, banana fresca, frutillas, chocolate y crema batida.",
        price: 6.0,
      },
      {
        id: "pos8",
        featured: true,
        name: "Cheesecake Frutos Rojos",
        description: "Disfruta de la suave textura de nuestro cheesecake cremoso bañado en una de las mejores salsas de frutos rojos.",
        price: 3.5,
        image: cheescake
      },
      {
        id: "pos9",
        name: "Tres Leches",
        description: "Saborea la jugosa dulzura de nuestro bizcocho bañado en tres leches, esponjoso y tradicional.",
        price: 2.75,
      },
      {
        id: "pos10",
        name: "Tiramisú",
        description: "Deléitate con este clásico postre italiano con capas de bizcocho remojado en café, cacao y crema de mascarpone.",
        price: 3.5,
      },
      {
        id: "pos11",
        name: "Mousse de Maracuyá",
        description: "Experimenta la frescura ácida y dulce de nuestro esponjoso mousse de maracuyá.",
        price: 2.75,
      },
    ],
  },
];
